export default __webpack_public_path__ + "static/media/recipes_dark.710d1c57.png";